import * as React from 'react';

import { inCustomBreakpoint, useWindowDimensions } from '../../../../../../hooks/useDimensions';
import { MIN_WIDTH_EXPANDABLE } from '../../../BaseDrawerLayout/BaseDrawerLayout.styles';
import { useDrawerLayoutContext } from '../../../BaseDrawerLayout/context';
import { IconContainer, StyledNavigationButton, StyledNavLink, TextContainer } from './NavigationButton.styles';

interface NavigationButtonPops {
  icon: React.ReactNode;
  isActive: boolean;
  onClick?: (e: any) => void;
  children: React.ReactNode;
}
const NavigationButton = ({ onClick, icon, children, isActive }: React.PropsWithChildren<NavigationButtonPops>) => {
  const { width } = useWindowDimensions();
  // Dependencies
  const { isOpened: isDrawerOpened } = useDrawerLayoutContext();
  const isOpened = inCustomBreakpoint(MIN_WIDTH_EXPANDABLE, width) && isDrawerOpened;

  return (
    <StyledNavLink onClick={onClick} $isActive={isActive}>
      <StyledNavigationButton $drawerIsOpen={isOpened}>
        <IconContainer>{icon}</IconContainer>
        {isOpened && <TextContainer $drawerIsOpen={isOpened}>{children}</TextContainer>}
      </StyledNavigationButton>
    </StyledNavLink>
  );
};

export default NavigationButton;
